import React from 'react';
import cx from 'classnames';
import styles from './styles.module.less';

const ProvisionalSelectBtnImage: React.FC<ProvisionalSelectBtnImageProps> = ({
  label,
  icon,
  isActive,
  onClick,
}) => (
  <div className={cx(styles.shapesOption, { [styles.shapesOptionActive]: isActive })}>
    <button
      type="button"
      aria-pressed={isActive}
      onClick={onClick}
      className={styles.shapesIconWrap}
    >
      <img src={icon} alt={label} className={styles.shapesIcon} />
    </button>
    <span>{label}</span>
  </div>
);

type ProvisionalSelectBtnImageProps = {
  label: string;
  icon: string;
  isActive: boolean;
  onClick: () => void;
};

export default ProvisionalSelectBtnImage;
